import classNames from "classnames";
import { useState } from "react";
import i18n from "../../../../../i18n";
import { InvoiceApprovalChain, RACInvoiceType } from "../../RACInterfaces";
import "./RACInvoiceTypeCostCenterView.scss";
import RACInvoiceTypeCostCenterList from "./components/RACInvoiceTypeCostCenterList";
import RACInvoiceTypeList from "./components/RACInvoiceTypeList";
import { Invoice } from "@/apps/tatar/invoiceApp/RAInterfaces";

interface RACInvoiceTypeCostCenterViewProps {
  invoice: Invoice;
}
const RACInvoiceTypeCostCenterView = (
  props: RACInvoiceTypeCostCenterViewProps
) => {
  const [selectedInvoiceType, setselectedInvoiceType] =
    useState<RACInvoiceType>(null);

  const onSelectInvoiceType = (invoiceType: RACInvoiceType) => {
    setselectedInvoiceType(invoiceType);
  };
  return (
    <div className={classNames("rac-invoice-type-cost-center")}>
      <div className="cost-conter-view-content">
        <div className="__card rac-invoice-type-list-content">
          <div className="rac-invoice-type-cost-center-header">
            {i18n.t(
              "rac:InvoiceTypeCostCenterConfig.InvoiceType",
              "Rechnungstyp"
            )}
          </div>
          <RACInvoiceTypeList
            onSelectInvoiceType={onSelectInvoiceType}
            selectedNode={selectedInvoiceType}
          />
        </div>
        {selectedInvoiceType && (
          <div className="rac-invoice-type-cost-center-list">
            <RACInvoiceTypeCostCenterList invoiceType={selectedInvoiceType} />
          </div>
        )}
      </div>
    </div>
  );
};

export default RACInvoiceTypeCostCenterView;
